import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------*\
    #LIST
\*------------------------------------ */
:host {
  display: contents;
}

/**
 * 1) Generic stacked list that allows for styling of borders in between items
 */
.cat-c-list {
  padding: 0;
  margin: 0;
  list-style: none;
  cursor: auto;
}

.cat-c-list.cat-c-list--steppedmegamenu {
  padding: 0;
  margin: 0;
  padding-block: calc(var(--size-base-unit) * 1) calc(var(--size-base-unit) * 1);
  list-style: none;
  cursor: auto;
  width: var(--cat-list-width, auto);
  height: var(--cat-list-height, 100%);
  max-height: calc(100vh - (var(--size-base-unit) * 2) - var(--cat-navbar-height, calc(var(--size-base-unit) * 7)));
  overflow-y: auto;
  box-shadow: var(--cat-theme-box-shadow-sm);
}
.cat-c-list.cat-c-list--steppedmegamenu::-webkit-scrollbar {
  width: calc(var(--size-base-unit) * 0.5);
  flex-shrink: calc(var(--size-base-unit) * 0);
  border-radius: calc(var(--size-base-unit) * 0.25);
  background: var(--cat-theme-color-background-subtle-hover);
  box-shadow: var(0 0 2px 0 #ffffff, 0 0 2px 0 #ffffff, --cat-list-scroll-shadow);
}
.cat-c-list.cat-c-list--steppedmegamenu::-webkit-scrollbar-track {
  border-radius: calc(var(--size-base-unit) * 1.5);
  background: var(--cat-theme-color-background-subtle);
  margin-inline-start: var(--cat-table-scrollbar-margin-left);
  margin-block-start: var(--cat-table-scrollbar-margin-top);
}
.cat-c-list.cat-c-list--steppedmegamenu::-webkit-scrollbar-thumb {
  background: var(--cat-theme-color-background-subtle-hover);
  border-radius: calc(var(--size-base-unit) * 1.5);
}

/**
 * 1) Container that becomes a scrolling carousel of components that you place inside when not enough room exists for all to display
 * 2) Wrapper needed around base list for shadows
 */
.cat-c-list-overflow-wrapper {
  overflow: auto;
  position: relative;
  /**
   * Left overflow gradient for the overflow list
   */
  /**
   * Right overflow gradient for the overflow list
   */
}
.cat-c-list-overflow-wrapper.cat-is-overflow-left:before {
  content: "";
  display: block;
  position: absolute;
  background: linear-gradient(var(--rtlGradientToRight, 90deg), var(--cat-theme-color-background-subtle) 0%, var(--cat-theme-color-background-transparent-subtle) 81.31%);
  height: calc(100% - var(--cat-list-scroll-padding, calc(var(--size-base-unit) * 0)));
  inset-block-start: 0;
  inset-inline-start: 0;
  width: calc(var(--size-base-unit) * 6);
  z-index: 1;
}
.cat-c-list-overflow-wrapper.cat-is-overflow-right:after {
  content: "";
  display: block;
  position: absolute;
  background: linear-gradient(var(--rtlGradientToRight, 90deg), var(--cat-theme-color-background-transparent-subtle) 0%, var(--cat-theme-color-background-subtle) 81.31%);
  height: calc(100% - var(--cat-list-scroll-padding, calc(var(--size-base-unit) * 0)));
  inset-block-start: 0;
  inset-inline-end: 0;
  width: calc(var(--size-base-unit) * 6);
  z-index: 1;
}

/**
 * Overflow list with subtle shadow
 */
.cat-c-list-overflow-wrapper--shadow-subtle {
  /**
   * Left overflow gradient for the overflow list
   */
  /** 
   * Right overflow gradient for the overflow list
   */
}
.cat-c-list-overflow-wrapper--shadow-subtle.cat-is-overflow-left:before {
  background: linear-gradient(var(--rtlGradientToRight, 90deg), var(--cat-theme-color-background-subtle) 0%, transparent 100%);
}
.cat-c-list-overflow-wrapper--shadow-subtle.cat-is-overflow-right:after {
  background: linear-gradient(var(--rtlGradientToRight, 90deg), transparent 0%, var(--cat-theme-color-background-subtle) 100%);
}

/**
 * Horizontal list
 * 1) Displays list item in a row
 */
.cat-c-list--horizontal {
  display: flex;
  flex-wrap: wrap;
  gap: calc(var(--size-base-unit) * 1);
}

/**
 * Overflow list
 * 1) Displays list item in a row that scrolls if the wrapper overflows
 */
.cat-c-list--overflow {
  flex-wrap: nowrap;
  overflow: auto;
  padding-block-end: var(--cat-list-scroll-padding, 0);
}
`;
       